import { render, staticRenderFns } from "./CollapsibleLinksList.vue?vue&type=template&id=5cc267b0&"
import script from "./CollapsibleLinksList.vue?vue&type=script&lang=js&"
export * from "./CollapsibleLinksList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VExpandTransition } from 'vuetify/lib/components/transitions';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardActions,VDivider,VExpandTransition,VIcon,VSpacer})


/* hot reload */
if (module.hot) {
  var api = require("/home/semaphore/fabric-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5cc267b0')) {
      api.createRecord('5cc267b0', component.options)
    } else {
      api.reload('5cc267b0', component.options)
    }
    module.hot.accept("./CollapsibleLinksList.vue?vue&type=template&id=5cc267b0&", function () {
      api.rerender('5cc267b0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/imageDocumentDetails/CollapsibleLinksList.vue"
export default component.exports